module.exports = __webpack_public_path__ + "static/media/Horizontal.6ba0cf9d.png";